import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchcomponents, fetchPageTemplate, fetchsettings } from "../Reducers/actions";
import { message } from "../../../Reducers/loading/actions";
import moment from "moment";

const ModernTypesManager = ({ 
  components, 
  templates, 
  settings, 
  fetchcomponents, 
  fetchPageTemplate, 
  fetchsettings,
  message 
}) => {
  const [activeTab, setActiveTab] = useState("components");
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalComponents: 0,
    totalTemplates: 0,
    totalPages: 0,
    totalElements: 0
  });

  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          fetchsettings(),
          fetchcomponents(),
          fetchPageTemplate()
        ]);
        
        // Calculate statistics
        calculateStats();
        setLoading(false);
      } catch (error) {
        message(4000, "danger", "Fout bij laden van data");
        setLoading(false);
      }
    };
    
    loadData();
  }, []);

  const calculateStats = () => {
    const totalComponents = components?.length || 0;
    const totalTemplates = templates?.length || 0;
    const totalPages = (settings?.website?.length || 0) + (settings?.onderdelen?.length || 0);
    const totalElements = totalComponents + totalTemplates + totalPages;
    
    setStats({
      totalComponents,
      totalTemplates,
      totalPages,
      totalElements
    });
  };

  useEffect(() => {
    calculateStats();
  }, [components, templates, settings]);

  const filteredComponents = components?.filter(component => 
    component.naam?.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  const filteredTemplates = templates?.filter(template => 
    template.naam?.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  const getComponentIcon = (type) => {
    const icons = {
      'text': 'fa-font',
      'image': 'fa-image',
      'button': 'fa-hand-pointer',
      'form': 'fa-wpforms',
      'video': 'fa-video',
      'gallery': 'fa-images',
      'accordion': 'fa-list',
      'slider': 'fa-sliders-h',
      'contact': 'fa-envelope',
      'map': 'fa-map-marker',
      'table': 'fa-table',
      'chart': 'fa-chart-bar'
    };
    return icons[type] || 'fa-puzzle-piece';
  };

  const getTemplateIcon = (type) => {
    return 'fa-file-code';
  };

  if (loading) {
    return (
      <div className="modern-types-manager">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <h5 className="text-muted">Types laden...</h5>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-types-manager">
      {/* Header */}
      <div className="types-header mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="h2 mb-1">Types & Templates Manager</h1>
            <p className="text-muted mb-0">Beheer je componenten, templates en pagina-elementen</p>
          </div>
          <div className="d-flex gap-2">
            <Link to="/cms/types/componenten/new" className="btn btn-success">
              <i className="fa fa-plus me-2"></i>
              Nieuw Component
            </Link>
            <Link to="/cms/types/templates/new" className="btn btn-primary">
              <i className="fa fa-plus me-2"></i>
              Nieuw Template
            </Link>
          </div>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card stats-card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="h4 mb-1">{stats.totalComponents}</div>
                  <div className="small">Componenten</div>
                </div>
                <div className="icon-container">
                  <i className="fa fa-puzzle-piece fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card stats-card bg-success text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="h4 mb-1">{stats.totalTemplates}</div>
                  <div className="small">Templates</div>
                </div>
                <div className="icon-container">
                  <i className="fa fa-file-code fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card stats-card bg-warning text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="h4 mb-1">{stats.totalPages}</div>
                  <div className="small">Pagina Types</div>
                </div>
                <div className="icon-container">
                  <i className="fa fa-sitemap fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card stats-card bg-info text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="h4 mb-1">{stats.totalElements}</div>
                  <div className="small">Totaal Elementen</div>
                </div>
                <div className="icon-container">
                  <i className="fa fa-cubes fa-2x opacity-75"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="card mb-4">
        <div className="card-header border-0">
          <div className="d-flex justify-content-between align-items-center">
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'components' ? 'active' : ''}`}
                  onClick={() => setActiveTab('components')}
                >
                  <i className="fa fa-puzzle-piece me-2"></i>
                  Componenten ({stats.totalComponents})
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'templates' ? 'active' : ''}`}
                  onClick={() => setActiveTab('templates')}
                >
                  <i className="fa fa-file-code me-2"></i>
                  Templates ({stats.totalTemplates})
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'pages' ? 'active' : ''}`}
                  onClick={() => setActiveTab('pages')}
                >
                  <i className="fa fa-sitemap me-2"></i>
                  Pagina Types ({stats.totalPages})
                </button>
              </li>
            </ul>

            <div className="d-flex gap-2 align-items-center">
              <div className="input-group" style={{ width: "300px" }}>
                <span className="input-group-text">
                  <i className="fa fa-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Zoeken..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn btn-outline-secondary ${viewMode === 'grid' ? 'active' : ''}`}
                  onClick={() => setViewMode('grid')}
                >
                  <i className="fa fa-th"></i>
                </button>
                <button
                  type="button"
                  className={`btn btn-outline-secondary ${viewMode === 'list' ? 'active' : ''}`}
                  onClick={() => setViewMode('list')}
                >
                  <i className="fa fa-list"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="types-content">
        {/* Components Tab */}
        {activeTab === 'components' && (
          <div className="components-section">
            {viewMode === 'grid' ? (
              <div className="row">
                {filteredComponents.map(component => (
                  <div key={component._id} className="col-lg-4 col-md-6 mb-4">
                    <div className="card component-card h-100">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="component-icon">
                          <i className={`fa ${getComponentIcon(component.type)} fa-2x text-primary`}></i>
                        </div>
                        <div className="d-flex gap-1">
                          <span className="badge bg-primary">Component</span>
                          {component.isReusable && (
                            <span className="badge bg-success">Herbruikbaar</span>
                          )}
                        </div>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">
                          <Link to={`/cms/types/componenten/edit/${component._id}`} className="text-decoration-none">
                            {component.naam || 'Naamloos Component'}
                          </Link>
                        </h5>
                        <p className="card-text text-muted small">
                          {component.description || 'Geen beschrijving beschikbaar'}
                        </p>
                        <div className="component-meta mt-auto">
                          <small className="text-muted">
                            <i className="fa fa-clock me-1"></i>
                            Gewijzigd {moment(component.updated || component.date).fromNow()}
                          </small>
                        </div>
                      </div>
                      <div className="card-footer bg-transparent">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex gap-1">
                            <Link 
                              to={`/cms/types/componenten/edit/${component._id}`}
                              className="btn btn-outline-primary btn-sm"
                            >
                              <i className="fa fa-edit me-1"></i>
                              Bewerken
                            </Link>
                          </div>
                          <div className="dropdown">
                            <button 
                              className="btn btn-outline-secondary btn-sm dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="fa fa-ellipsis-h"></i>
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <button className="dropdown-item">
                                  <i className="fa fa-copy me-2"></i>Dupliceren
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item">
                                  <i className="fa fa-eye me-2"></i>Voorvertoning
                                </button>
                              </li>
                              <li><hr className="dropdown-divider" /></li>
                              <li>
                                <button className="dropdown-item text-danger">
                                  <i className="fa fa-trash me-2"></i>Verwijderen
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                
                {/* Add New Component Card */}
                <div className="col-lg-4 col-md-6 mb-4">
                  <Link to="/cms/types/componenten/new" className="text-decoration-none">
                    <div className="card component-card h-100 border-dashed">
                      <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                        <i className="fa fa-plus fa-3x text-primary mb-3"></i>
                        <h5 className="card-title text-primary">Nieuw Component</h5>
                        <p className="card-text text-muted small">
                          Maak een nieuw herbruikbaar component aan
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              // List View for Components
              <div className="card">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Component</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Gewijzigd</th>
                        <th style={{width: "120px"}}>Acties</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredComponents.map(component => (
                        <tr key={component._id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <i className={`fa ${getComponentIcon(component.type)} me-2 text-primary`}></i>
                              <div>
                                <Link to={`/cms/types/componenten/edit/${component._id}`} className="fw-semibold text-decoration-none">
                                  {component.naam || 'Naamloos Component'}
                                </Link>
                                {component.description && (
                                  <div className="small text-muted">{component.description}</div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-primary">
                              {component.type || 'Component'}
                            </span>
                          </td>
                          <td>
                            <span className="badge bg-success">
                              {component.isReusable ? 'Herbruikbaar' : 'Eenmalig'}
                            </span>
                          </td>
                          <td>
                            <span className="text-muted">
                              {moment(component.updated || component.date).format('DD-MM-YYYY HH:mm')}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Link 
                                to={`/cms/types/componenten/edit/${component._id}`}
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                              <button className="btn btn-outline-danger btn-sm">
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Templates Tab */}
        {activeTab === 'templates' && (
          <div className="templates-section">
            {viewMode === 'grid' ? (
              <div className="row">
                {filteredTemplates.map(template => (
                  <div key={template._id} className="col-lg-4 col-md-6 mb-4">
                    <div className="card template-card h-100">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="template-icon">
                          <i className={`fa ${getTemplateIcon(template.type)} fa-2x text-success`}></i>
                        </div>
                        <div className="d-flex gap-1">
                          <span className="badge bg-success">Template</span>
                        </div>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">
                          <Link to={`/cms/types/templates/edit/${template._id}`} className="text-decoration-none">
                            {template.naam || 'Naamloos Template'}
                          </Link>
                        </h5>
                        <p className="card-text text-muted small">
                          {template.description || 'Geen beschrijving beschikbaar'}
                        </p>
                        <div className="template-meta mt-auto">
                          <small className="text-muted">
                            <i className="fa fa-clock me-1"></i>
                            Gewijzigd {moment(template.updated || template.date).fromNow()}
                          </small>
                        </div>
                      </div>
                      <div className="card-footer bg-transparent">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex gap-1">
                            <Link 
                              to={`/cms/types/templates/edit/${template._id}`}
                              className="btn btn-outline-success btn-sm"
                            >
                              <i className="fa fa-edit me-1"></i>
                              Bewerken
                            </Link>
                          </div>
                          <div className="dropdown">
                            <button 
                              className="btn btn-outline-secondary btn-sm dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="fa fa-ellipsis-h"></i>
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <button className="dropdown-item">
                                  <i className="fa fa-copy me-2"></i>Dupliceren
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item">
                                  <i className="fa fa-eye me-2"></i>Voorvertoning
                                </button>
                              </li>
                              <li><hr className="dropdown-divider" /></li>
                              <li>
                                <button className="dropdown-item text-danger">
                                  <i className="fa fa-trash me-2"></i>Verwijderen
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                
                {/* Add New Template Card */}
                <div className="col-lg-4 col-md-6 mb-4">
                  <Link to="/cms/types/templates/new" className="text-decoration-none">
                    <div className="card template-card h-100 border-dashed">
                      <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                        <i className="fa fa-plus fa-3x text-success mb-3"></i>
                        <h5 className="card-title text-success">Nieuw Template</h5>
                        <p className="card-text text-muted small">
                          Maak een nieuwe pagina template aan
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              // List View for Templates
              <div className="card">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Template</th>
                        <th>Type</th>
                        <th>Componenten</th>
                        <th>Gewijzigd</th>
                        <th style={{width: "120px"}}>Acties</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTemplates.map(template => (
                        <tr key={template._id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <i className={`fa ${getTemplateIcon(template.type)} me-2 text-success`}></i>
                              <div>
                                <Link to={`/cms/types/templates/edit/${template._id}`} className="fw-semibold text-decoration-none">
                                  {template.naam || 'Naamloos Template'}
                                </Link>
                                {template.description && (
                                  <div className="small text-muted">{template.description}</div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-success">Template</span>
                          </td>
                          <td>
                            <span className="text-muted">
                              {template.content?.length || 0} elementen
                            </span>
                          </td>
                          <td>
                            <span className="text-muted">
                              {moment(template.updated || template.date).format('DD-MM-YYYY HH:mm')}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Link 
                                to={`/cms/types/templates/edit/${template._id}`}
                                className="btn btn-outline-success btn-sm"
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                              <button className="btn btn-outline-danger btn-sm">
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Pages Tab */}
        {activeTab === 'pages' && (
          <div className="pages-section">
            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">
                      <i className="fa fa-sitemap me-2"></i>
                      Website Pagina's
                    </h5>
                  </div>
                  <div className="card-body">
                    {settings?.website?.length ? (
                      <div className="list-group list-group-flush">
                        {settings.website.map((page, index) => (
                          <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">{page.naam}</h6>
                              <small className="text-muted">/{page.slug}</small>
                            </div>
                            <div className="d-flex gap-1">
                              <Link 
                                to={`/cms/pages?slug=${page.slug}&naam=${page.naam}&pageType=pagina`}
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-3">
                        <i className="fa fa-sitemap fa-2x text-muted mb-2"></i>
                        <p className="text-muted">Geen website pagina's gevonden</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">
                      <i className="fa fa-puzzle-piece me-2"></i>
                      Pagina Onderdelen
                    </h5>
                  </div>
                  <div className="card-body">
                    {settings?.onderdelen?.length ? (
                      <div className="list-group list-group-flush">
                        {settings.onderdelen.map((onderdeel, index) => (
                          <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">{onderdeel.onderdeel}</h6>
                              <small className="text-muted">Herbruikbaar onderdeel</small>
                            </div>
                            <div className="d-flex gap-1">
                              <Link 
                                to={`/cms/pages?slug=false&naam=${onderdeel.onderdeel}&pageType=onderdeel`}
                                className="btn btn-outline-secondary btn-sm"
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-3">
                        <i className="fa fa-puzzle-piece fa-2x text-muted mb-2"></i>
                        <p className="text-muted">Geen pagina onderdelen gevonden</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Empty State */}
      {activeTab === 'components' && filteredComponents.length === 0 && (
        <div className="text-center py-5">
          <i className="fa fa-puzzle-piece fa-3x text-muted mb-3"></i>
          <h4 className="text-muted">Geen componenten gevonden</h4>
          <p className="text-muted mb-4">
            {searchTerm ? "Probeer een andere zoekterm" : "Maak je eerste component aan"}
          </p>
          <Link to="/cms/types/componenten/new" className="btn btn-success">
            <i className="fa fa-plus me-2"></i>
            Nieuw Component
          </Link>
        </div>
      )}

      {activeTab === 'templates' && filteredTemplates.length === 0 && (
        <div className="text-center py-5">
          <i className="fa fa-file-code fa-3x text-muted mb-3"></i>
          <h4 className="text-muted">Geen templates gevonden</h4>
          <p className="text-muted mb-4">
            {searchTerm ? "Probeer een andere zoekterm" : "Maak je eerste template aan"}
          </p>
          <Link to="/cms/types/templates/new" className="btn btn-primary">
            <i className="fa fa-plus me-2"></i>
            Nieuw Template
          </Link>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  components: state.cms.components.items,
  templates: state.cms.templates.items,
  settings: state.cms.settings
});

export default connect(mapStateToProps, {
  fetchcomponents,
  fetchPageTemplate,
  fetchsettings,
  message
})(ModernTypesManager);